"use client"

import { NuisibleUpdateInput } from '@repo/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NuisibleService } from '../../../lib/api/services/nuisible.service';

const nuisibleService = new NuisibleService();

export function useUpdateNuisible() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: NuisibleUpdateInput }) =>
      nuisibleService.updateNuisible(id, data),
    onSuccess: (_, { id }) => {
      // Invalidate and refetch nuisibles list and specific nuisible
      queryClient.invalidateQueries({ queryKey: ['nuisibles'] });
      queryClient.invalidateQueries({ queryKey: ['nuisible', id] });
    },
  });
}